import { observer } from 'mobx-react-lite';
import { FC, useMemo } from 'react';

import { getMascotImageSrc } from '@gem/utils';

import { ApplicationTheme } from 'APP/constants/appearance';
import Entities from 'STORE';

interface IImageThemeProps {
  lightImageName: string;
  darkImageName?: string;
  className?: string;
  width?: number;
  height?: number;
  alt?: string;
}

export const ImageTheme: FC<IImageThemeProps> = observer((props) => {
  const { darkImageName, lightImageName, className, width, height, alt = '' } = props;

  const imageName = useMemo(() => {
    if (Entities.appearance.theme === ApplicationTheme.Light) {
      return lightImageName;
    }

    return darkImageName || lightImageName;
  }, [lightImageName, darkImageName, Entities.appearance.theme]);

  if (!imageName) {
    return null;
  }

  return (
    <img
      width={width}
      height={height}
      src={getMascotImageSrc(imageName)}
      className={className}
      alt={alt}
    />
  );
});
